import styled, { css } from 'styled-components';
import Typography from '../Typography';
import { ListItemProps, ListProps, MaxHeight } from './types';

export const Title = styled(Typography).attrs({ as: 'h3' })`
  font-weight: ${({ theme }) => theme.font.weight.bold};
  color: ${({ theme }) => theme.color.text.neutral.strong};
`;

export const Text = styled.span`
  color: ${({ theme }) => theme.color.text.neutral.default};
  font-size: ${({ theme }) => theme.font.size.m3};
  font-weight: ${({ theme }) => theme.font.weight.bold};
  line-height: ${({ theme }) => theme.font.lineHeight.large};
`;

export const ListItem = styled.li<ListItemProps>`
  padding: ${({ theme }) => `${theme.spacing.km3} ${theme.spacing.km6}`};
  list-style: none;

  ${({ clickable = false }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

  &:hover {
    background: ${({ theme }) => theme.color.background.neutral.weak};
  }
`;

export const List = styled.ul<ListProps>`
  padding: 0;
  margin: 0;
  list-style: none;

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      max-height: ${heighMapping($maxHeight)};
      overflow: auto;
    `}

  ${ListItem} {
    ${({ borderRadiusOnFirstItem = true, theme }) =>
      borderRadiusOnFirstItem &&
      css`
        &:first-child {
          border-top-left-radius: ${theme.border.radius.large};
          border-top-right-radius: ${theme.border.radius.large};
        }
      `}
    &:last-child {
      border-bottom-left-radius: ${({ theme }) => theme.border.radius.large};
      border-bottom-right-radius: ${({ theme }) => theme.border.radius.large};
    }
  }
`;

function heighMapping(maxHeight: MaxHeight) {
  const heightMap = {
    sm: '200px',
    md: '400px',
    lg: '800px',
  };

  return heightMap[maxHeight];
}
